// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_2m9a1","socialSharer":"yXQf6","video":"_2rvzQ","translationButton":"_3YU1Q"};